import { taskRailRoutes } from '@modules/Tasks/Resources/js/utils/taskRailRoutes';

export default {
    slug: 'work_orders',
    ability: 'work_orders',
    routes: [
        {
            path: 'dispatch',
            name: 'work-order-dispatch',
            component: () => import('@modules/WorkOrders/Resources/js/pages/DispatchBoard.vue')
        },
        {
            path: 'dispatch-map',
            name: 'work-order-dispatch-map',
            component: () => import('@modules/WorkOrders/Resources/js/pages/DispatchMap.vue')
        },
        {
            path: 'my-day',
            name: 'work-order-my-day',
            component: () => import('@modules/WorkOrders/Resources/js/pages/MyDay.vue')
        },
        {
            path: 'my-truck',
            name: 'work-order-my-truck',
            component: () => import('@modules/WorkOrders/Resources/js/pages/MyTruck.vue')
        },
        {
            path: 'work-orders',
            name: 'work-order-list',
            component: () => import('@modules/WorkOrders/Resources/js/pages/List.vue'),
            // What the list asks for as it opens, in one request (utils/listBootstrap.js).
            meta: { listBootstrap: { list: 'work_orders' } },
            children: [
                {
                    path: 'new',
                    name: 'work-order-new',
                    component: () => import('@modules/WorkOrders/Resources/js/pages/NewFromSource.vue'),
                    props: route => ({
                        sourceType: route.query.source_type || null,
                        sourceId: route.query.source_id ? Number(route.query.source_id) : null
                    })
                },
                {
                    path: ':id(\\d+)',
                    name: 'work-order-preview',
                    component: () => import('@modules/WorkOrders/Resources/js/pages/Preview.vue'),
                    redirect: { name: 'work-order-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/work-orders/:id(\\d+)',
                            name: 'work-order-overview',
                            component: () => import('@modules/WorkOrders/Resources/js/pages/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'interventions',
                            name: 'work-order-interventions',
                            component: () =>
                                import('@modules/WorkOrders/Resources/js/pages/preview/TabInterventions.vue'),
                            props: true
                        },
                        {
                            path: 'diagnostic',
                            name: 'work-order-diagnostic',
                            component: () => import('@modules/WorkOrders/Resources/js/pages/preview/TabDiagnostic.vue'),
                            props: true
                        },
                        {
                            path: 'reports',
                            name: 'work-order-reports',
                            component: () => import('@modules/WorkOrders/Resources/js/pages/preview/TabReports.vue'),
                            props: true,
                            // The feed narrowed to one visit is this tab's own
                            // reading: it does not follow to another tab.
                            meta: { tabQuery: ['intervention'] }
                        },
                        {
                            path: 'items',
                            name: 'work-order-items',
                            component: () => import('@modules/WorkOrders/Resources/js/pages/preview/TabItems.vue'),
                            props: true,
                            // `plan` opens the material plan, `import_materials` fills it from
                            // the quote: the tab's own keys, not filters for the list beside it.
                            meta: { tabQuery: ['plan', 'import_materials'] }
                        },
                        {
                            path: 'procurement',
                            name: 'work-order-procurement',
                            component: () =>
                                import('@modules/WorkOrders/Resources/js/pages/preview/TabProcurement.vue'),
                            props: true
                        },
                        {
                            path: 'checklist',
                            name: 'work-order-checklist',
                            component: () => import('@modules/WorkOrders/Resources/js/pages/preview/TabChecklist.vue'),
                            props: true,
                            children: taskRailRoutes('work-order-checklist')
                        },
                        {
                            path: 'phases',
                            name: 'work-order-phases',
                            component: () => import('@modules/WorkOrders/Resources/js/pages/preview/TabPhases.vue'),
                            props: true,
                            children: taskRailRoutes('work-order-phases')
                        },
                        {
                            path: 'deliveries',
                            name: 'work-order-deliveries',
                            component: () => import('@modules/WorkOrders/Resources/js/pages/preview/TabDeliveries.vue'),
                            props: true
                        },
                        {
                            path: 'timesheets',
                            name: 'work-order-timesheets',
                            component: () => import('@modules/WorkOrders/Resources/js/pages/preview/TabTimesheets.vue'),
                            props: true
                        },
                        {
                            path: 'activities',
                            name: 'work-order-activities',
                            component: () => import('@/components/base/tabs/TabActivities.vue'),
                            props: true
                        },
                        {
                            path: 'comments',
                            name: 'work-order-comments',
                            component: () => import('@/components/base/tabs/TabComments.vue'),
                            props: true
                        },
                        {
                            path: 'photos',
                            name: 'work-order-photos',
                            component: () => import('@/components/base/tabs/TabPictures.vue'),
                            props: true
                        },
                        {
                            path: 'documents/:docPath(.*)*',
                            name: 'work-order-documents',
                            component: () => import('@/components/base/tabs/TabDocuments.vue'),
                            props: true
                        },
                        {
                            path: 'related',
                            name: 'work-order-related',
                            component: () =>
                                import('@modules/WorkOrders/Resources/js/pages/preview/RelatedDocuments.vue'),
                            props: true
                        },
                        {
                            path: 'billing',
                            name: 'work-order-billing',
                            component: () => import('@modules/WorkOrders/Resources/js/pages/preview/TabBilling.vue'),
                            props: true
                        },
                        {
                            path: 'profitability',
                            name: 'work-order-profitability',
                            component: () =>
                                import('@modules/WorkOrders/Resources/js/pages/preview/TabProfitability.vue'),
                            props: true
                        },
                        {
                            path: 'logs',
                            name: 'work-order-logs',
                            component: () => import('@/components/base/tabs/TabLogs.vue'),
                            props: true
                        },
                        {
                            path: 'document-requests',
                            name: 'work-order-document-requests',
                            component: () => import('@/components/base/tabs/TabDocumentRequests.vue'),
                            props: true
                        },
                        {
                            path: 'contracts',
                            name: 'work-order-contracts',
                            component: () => import('@/components/base/tabs/TabContracts.vue'),
                            props: true
                        }
                    ]
                }
            ]
        }
    ],
    // Declared here because the section holds nothing else: its two tabs are
    // both Work Orders'. An organization without the module has no operations
    // settings to reach.
    settings: () => {
        const title = i18n.t('Operations');

        return [
            {
                title: i18n.t('Applications'),
                order: 10,
                items: [
                    { title, icon: 'format-list-bulleted', route: 'settings-operations', admin: true, position: 40 }
                ]
            }
        ];
    },
    portalRoutes: [
        {
            path: 'visits',
            name: 'portal-visits',
            component: () => import('@modules/WorkOrders/Resources/js/portal/Visits.vue')
        },
        {
            path: 'visits/:id(\\d+)',
            name: 'portal-visit-detail',
            component: () => import('@modules/WorkOrders/Resources/js/portal/VisitDetail.vue'),
            props: true
        }
    ],
    operationsRoutes: [
        {
            path: 'works',
            alias: ['projects'],
            name: 'settings-operations-work',
            component: () => import('@modules/WorkOrders/Resources/js/pages/settings/WorkSettings.vue')
        },
        {
            path: 'work-orders',
            name: 'settings-operations-work-orders',
            component: () => import('@modules/WorkOrders/Resources/js/pages/settings/WorkOrderTypeSettings.vue'),
            props: true
        },
        {
            path: 'work-orders/new',
            name: 'settings-work-order-type-new',
            component: () => import('@modules/WorkOrders/Resources/js/pages/settings/WorkOrderTypeEdit.vue')
        },
        {
            path: 'work-orders/:id(\\d+)/edit',
            name: 'settings-work-order-type-edit',
            component: () => import('@modules/WorkOrders/Resources/js/pages/settings/WorkOrderTypeEdit.vue'),
            props: true
        }
    ],
    widgets: () => [
        {
            id: 'executive-totals',
            label: i18n.t('Executive totals'),
            icon: 'chart-box-outline',
            component: () => import('@modules/WorkOrders/Resources/js/pages/dashboards/widgets/ExecutiveTotals.vue'),
            size: 'is-4',
            module: 'work_orders'
        },
        {
            id: 'executive-top-customers',
            label: i18n.t('Top customers'),
            icon: 'account-star-outline',
            component: () =>
                import('@modules/WorkOrders/Resources/js/pages/dashboards/widgets/ExecutiveTopCustomers.vue'),
            size: 'is-4',
            module: 'work_orders',
            ability: 'accounting.sales.invoicing'
        },
        {
            id: 'executive-cash-flow',
            label: i18n.t('Cash flow forecast'),
            icon: 'cash-clock',
            component: () => import('@modules/WorkOrders/Resources/js/pages/dashboards/widgets/ExecutiveCashFlow.vue'),
            size: 'is-8',
            module: 'work_orders',
            ability: 'accounting.sales.invoicing'
        },
        {
            id: 'wo-today',
            label: i18n.t('Work orders today'),
            icon: 'calendar-clock',
            component: () => import('@modules/WorkOrders/Resources/js/pages/dashboards/widgets/WoToday.vue'),
            size: 'is-6',
            module: 'work_orders'
        },
        {
            id: 'wo-urgent-alerts',
            label: i18n.t('Urgent alerts'),
            icon: 'alert-circle-outline',
            component: () => import('@modules/WorkOrders/Resources/js/pages/dashboards/widgets/WoUrgentAlerts.vue'),
            size: 'is-4',
            module: 'work_orders'
        },
        {
            id: 'wo-active-technicians',
            label: i18n.t('Active technicians'),
            icon: 'account-hard-hat',
            component: () =>
                import('@modules/WorkOrders/Resources/js/pages/dashboards/widgets/WoActiveTechnicians.vue'),
            size: 'is-4',
            module: 'work_orders'
        },
        {
            id: 'wo-active-jobs',
            label: i18n.t('Active jobs'),
            icon: 'hammer-screwdriver',
            component: () => import('@modules/WorkOrders/Resources/js/pages/dashboards/widgets/WoActiveJobs.vue'),
            size: 'is-6',
            module: 'work_orders'
        },
        {
            id: 'wo-ready-to-invoice',
            label: i18n.t('Ready to invoice'),
            icon: 'file-document-outline',
            component: () => import('@modules/WorkOrders/Resources/js/pages/dashboards/widgets/WoReadyToInvoice.vue'),
            size: 'is-4',
            module: 'work_orders'
        },
        {
            id: 'wo-recent-interventions',
            label: i18n.t('Recent interventions'),
            icon: 'history',
            component: () =>
                import('@modules/WorkOrders/Resources/js/pages/dashboards/widgets/WoRecentInterventions.vue'),
            size: 'is-6',
            module: 'work_orders'
        },
        {
            id: 'wo-warranties-expiring',
            label: i18n.t('Warranty expiring soon (30 days)'),
            icon: 'calendar-refresh-outline',
            component: () =>
                import('@modules/WorkOrders/Resources/js/pages/dashboards/widgets/WoWarrantiesExpiring.vue'),
            size: 'is-4',
            module: 'work_orders'
        }
    ],
    nav: () => ({
        section: 'projects',
        items: [
            {
                title: i18n.t('Work Orders'),
                icon: 'briefcase-outline',
                to: { name: 'work-order-list' }
            },
            {
                title: i18n.t('Dispatch board'),
                icon: 'calendar-clock-outline',
                to: { name: 'work-order-dispatch' },
                visible: orgStore => orgStore.can('work_orders')
            },
            {
                title: i18n.t('My truck'),
                icon: 'truck-outline',
                to: { name: 'work-order-my-truck' },
                visible: orgStore => !!orgStore.defaultWarehouse
            }
        ]
    })
};
